import {
  GET_APPOINMENT_DETAILS,
  GET_MER_LIBRARY,
  GET_APPOINMENT_TIME_SLOT,
  GET_APPOINMENT_HISTORY,
  GET_APPOINMENT_UPLOAD_REPORT,
  IS_SHOW_POPUP,
  GET_PROVIDER_NAME_DETAILS,
  GET_CLIENT_NAME_DETAILS,
  GET_APPOINMENT_QUEUE_DETAILS,
  GET_APPOINTMENT_COUNT,
  GET_STATUS_REASON,
  GET_WHATSAPP_APPOINTMENT_DETAILS,
  GET_WHATSAPP_APPOINMENT_UPLOAD_REPORT,
  GET_PROVIDERDETAILS,
  GET_WHATSAPP_STATUS_REASON,
  PARTIAL_TEST_DETAIL
} from "../../Utils/types";

const initialState = {
  getAppoinmentDetail: null,
  getAppoinmentQueueDetail: [],
  getMerLibrary: null,
  getAppoinmentExcelDetail: null,
  getAppoinmentTimeSlot: null,
  getAppoinmentHistory: null,
  getAppoinmentUploadReport: null,
  getProviderNameDetails: null,
  getClientNameDetails: null,
  getAppointmentCount: null,
  isShowPopup: false,
  getStatusReason: [],
  getWhatsappStatusReason: [],
  getWhatsappAppointmentDetails: [],
  getWhatsappAppoinmentUploadReport: null,
  getProviderDetails: null,
  partialTestDetail:[]
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_APPOINMENT_DETAILS:
      return {
        ...state,
        getAppoinmentDetail: action.payload,
      };
    case PARTIAL_TEST_DETAIL:
      return {
        ...state,
        partialTestDetail: action.payload,
      };
    case GET_APPOINMENT_QUEUE_DETAILS:
      return {
        ...state,
        getAppoinmentQueueDetail: action.payload,
      };
    case GET_APPOINTMENT_COUNT:
      return {
        ...state,
        getAppointmentCount: action.payload,
      };
    case GET_MER_LIBRARY:
      return {
        ...state,
        getMerLibrary: action.payload,
      };
    case GET_APPOINMENT_TIME_SLOT:
      return {
        ...state,
        getAppoinmentTimeSlot: action.payload,
      };
    case GET_APPOINMENT_HISTORY:
      return {
        ...state,
        getAppoinmentHistory: action.payload,
      };
    case GET_APPOINMENT_UPLOAD_REPORT:
      return {
        ...state,
        getAppoinmentUploadReport: action.payload,
      };
    case IS_SHOW_POPUP:
      return {
        ...state,
        isShowPopup: action.payload,
      };
    case GET_PROVIDER_NAME_DETAILS:
      return {
        ...state,
        getProviderNameDetails: action.payload,
      };
    case GET_CLIENT_NAME_DETAILS:
      return {
        ...state,
        getClientNameDetails: action.payload,
      };
    case GET_STATUS_REASON:
      return {
        ...state,
        getStatusReason: action.payload,
      };
    case GET_WHATSAPP_APPOINTMENT_DETAILS:
      return {
        ...state,
        getWhatsappAppointmentDetails: action.payload,
      };
    case GET_WHATSAPP_APPOINMENT_UPLOAD_REPORT:
      return {
        ...state,
        getWhatsappAppoinmentUploadReport: action.payload,
      };
    case GET_WHATSAPP_STATUS_REASON:
      return {
        ...state,
        getWhatsappStatusReason: action.payload,
      };
    case GET_PROVIDERDETAILS:
      return {
        ...state,
        getProviderDetails: action.payload,
      };
    default:
      return state;
  }
};
